/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rd_Fix_No_SecretsInputs */

const en_rd_fix_no_secrets = /** @type {(inputs: Rd_Fix_No_SecretsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Move those keys into environment variables, rotate them, and purge them from git history.`)
};

const id_rd_fix_no_secrets = /** @type {(inputs: Rd_Fix_No_SecretsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pindahkan kunci itu ke environment variable, rotasi, lalu bersihkan dari riwayat git.`)
};

/**
* | output |
* | --- |
* | "Move those keys into environment variables, rotate them, and purge them from git history." |
*
* @param {Rd_Fix_No_SecretsInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const rd_fix_no_secrets = /** @type {((inputs?: Rd_Fix_No_SecretsInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rd_Fix_No_SecretsInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_rd_fix_no_secrets(inputs)
	return en_rd_fix_no_secrets(inputs)
});